var formInit;

(function ($) {

	const selectors = {
		form: 'form'
	}

	formInit = function () {
		$(selectors.form).each((i, el) => {
			new Form(el);
		});
	}

	class Form {
		constructor(element) {
			this.$form = $(element);

			if (this.$form.length) {
				this.init();
			}

		}

		init() {
			this.bind();
		}

		bind() {

			this.submit = this.submit.bind(this);

			$('[data-submit-on-change]', this.$form).on('change', this.submit);

		}

		submit() {
			this.$form.submit();
		}

	}

})(jQuery);


export default formInit;